@let link = tariffLink();
<iframe
  #iframe
  id="inlineFrameInsurance"
  title="Inline Frame insurance"
  class="w-full app-iframe"
  [src]="link ? link : sanitizedLink()"
  (load)="onLoad(iframe)">
</iframe>
<app-loading-spinner [loading]="loading()">
</app-loading-spinner>

